// extracted by mini-css-extract-plugin
module.exports = {"container":"Picture_container__3O-ym","image":"Picture_image__3a74Z","content":"Picture_content__3BBV_"};